<div class="dialog-content">
    <div class="dialog-icon-container">
      <mat-icon class="dialog-icon">info</mat-icon>
    </div>
    <h2 class="dialog-title">
      Are you sure you want to {{ data.action }} {{ data.count }} selected devices?
    </h2>
    <div class="dialog-actions">
      <button mat-button class="cancel-button" (click)="onNoClick()">No</button>
      <button mat-raised-button class="confirm-button" (click)="onYesClick()">
        Yes, {{ data.action }} Selected
      </button>
    </div>
  </div>